// extracted by css-extract-rspack-plugin
export default {"warning":"BulkDelete__warning--cNhQC","importantWarning":"BulkDelete__importantWarning--zAXkr BulkDelete__warning--cNhQC"};